import _ from 'lodash';
import { Types } from '../actions/legalActions';

const legalReducers = (state, action) => {
  switch (action.type) {
    case Types.CATALOGUE: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        ...newState.legal,
        catalogue: action.payload,
      };
      return newState;
    }

    case Types.STATUS: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        ...newState.legal,
        status: {
          outstanding: action.payload?.outstanding || [],
          satisfied: action.payload?.satisfied || [],
        },
      };
      return newState;
    }

    case Types.MARKDOWN: {
      const newState = _.cloneDeep(state);
      const cacheKey = `${action.documentKind}@${action.versionLabel}`;
      newState.legal = {
        ...newState.legal,
        markdownCache: {
          ...newState.legal?.markdownCache,
          [cacheKey]: action.markdown,
        },
      };
      return newState;
    }

    case Types.LOADING: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        ...newState.legal,
        loading: {
          ...newState.legal?.loading,
          [action.key]: action.value,
        },
      };
      return newState;
    }

    case Types.ERROR: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        ...newState.legal,
        error: action.error,
      };
      return newState;
    }

    case Types.PENDING_REGISTRATION: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        ...newState.legal,
        pendingRegistrationAcceptance: action.payload,
      };
      return newState;
    }

    case Types.CLEAR: {
      const newState = _.cloneDeep(state);
      newState.legal = {
        catalogue: null,
        status: { outstanding: [], satisfied: [] },
        markdownCache: {},
        loading: {},
        error: null,
        pendingRegistrationAcceptance: null,
      };
      return newState;
    }

    default:
      return state;
  }
};

export default legalReducers;
